import countries from 'i18n-iso-countries';
import getUnicodeFlagIcon from 'country-flag-icons/unicode';

// Initialize the i18n-iso-countries library with English locale
import enLocale from 'i18n-iso-countries/langs/en.json';
countries.registerLocale(enLocale);

// Get all country codes (alpha-2)
const countryCodes = Object.keys(countries.getAlpha2Codes());

// Create options for the select component
export const countryOptions = countryCodes
  .map(code => {
    // Get the country name
    let name = countries.getName(code, 'en');
    if (!name) return null;
    
    // Special case for Taiwan
    if (code === 'TW' && name === 'Taiwan, Province of China') {
      name = 'Taiwan';
    }
    
    // Get the flag emoji
    const flagEmoji = getUnicodeFlagIcon(code);
    
    return {
      value: code,
      label: `${flagEmoji} ${name}`,
      name: name
    };
  })
  .filter(Boolean) // Remove null entries
  .sort((a, b) => a!.name.localeCompare(b!.name)); // Sort alphabetically by name

// Function to get country name from code
export const getCountryNameFromCode = (code: string): string => {
  // Special case for Taiwan
  if (code === 'TW') {
    return 'Taiwan';
  }
  return countries.getName(code, 'en') || code;
};

/**
 * Defines the list of countries where the BasedApp service is currently available.
 * Using 'as const' ensures the array elements are treated as literal types 
 * and the array itself is readonly, preventing accidental modifications.
 */
export const eligibleCountries = ['SG', 'MY', 'HK'] as const;

/**
 * Type representing an eligible country based on the eligibleCountries list.
 */
export type EligibleCountry = typeof eligibleCountries[number];